module.exports = __webpack_public_path__ + "static/a6aff6640eb9b32193bdaca74a97d0c59022d8bb0c9ae895329dc3e7d2cf3a4c-b0a728b7192c8f513922db6d7e6958e6.jpeg";